import axios from "axios";

// Use REACT_APP_LOGINURL which always gives base URL with /api/
const BASE_URL = process.env.REACT_APP_LOGINURL || "http://localhost:3005/api/";

// Construct notification API URL
const API_URL = BASE_URL.replace(/\/$/, '') + '/NotificationRoutes';

const headers = {
  'Content-Type': 'application/json',
  'token': localStorage.getItem("session-id")
}

// Get all notifications for logged-in user
const getNotifications = (postData = {}) => {
  var payload = {
    functionName: "GetNotifications",
    postData: {
      offset: postData.offset || 0,
      limit: postData.limit || 50,
      sort: postData.sort || { _id: -1 },
      filter: postData.filter || {},
      ...postData
    }
  }
  return axios.post(API_URL + "/GetNotifications", payload, { headers });
};

// Delete a notification
const deleteNotification = (notificationId) => {
  var payload = {
    functionName: "DeleteNotification",
    postData: {
      notification_id: notificationId
    }
  }
  return axios.post(API_URL + "/DeleteNotification", payload, { headers });
};

// Mark notification as read
const markAsRead = (notificationId = null) => {
  var payload = {
    functionName: "MarkNotificationAsRead",
    postData: {}
  }
  
  // If notificationId provided, mark only that one, otherwise mark all as read
  if (notificationId) {
    payload.postData.notification_id = notificationId;
  }
  
  return axios.post(API_URL + "/MarkNotificationAsRead", payload, { headers });
};

const NotificationService = {
  getNotifications,
  deleteNotification,
  markAsRead
};

export default NotificationService;

